
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import logoImage from '/src/images/Original.png';
import { navigate } from "gatsby";
import { MenuContext } from '../../../context/MenuContext';
import { AuthContext } from '../../../context/AuthContext';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Backdrop, CircularProgress, Divider, Drawer, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { LoadingContext } from '../../../context/LoadingContext';


// Check if window is defined (so if in the browser or in node.js).


const isBrowser = typeof window !== "undefined"


function Header() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElKategori, setAnchorElKategori] = React.useState(null);
  const [anchorElKategori2, setAnchorElKategori2] = React.useState(null);


  const {setLoading} = React.useContext(LoadingContext);

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const { pages, menuSettings } = React.useContext(MenuContext);

  debugger;

  /*
  if (!pages || pages.length <= 0) {
    if (isBrowser) {
      const cachePages = localStorage.getItem('pages');
      if (cachePages && cachePages.length > 0) {
        setPages(JSON.parse(cachePages));
      }
    }
  }
  */



  const visible4Pages = pages.slice(0, 4);
  const overflow4Pages = pages.slice(4);

  const visible6Pages = pages.slice(0, 6);
  const overflow6Pages = pages.slice(6);

  const { logout } = React.useContext(AuthContext);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenKategoriMenu = (event) => {
    setAnchorElKategori(event.currentTarget);
  };

  const handleCloseKategoriMenu = () => {
    setAnchorElKategori(null);
  };

  const handleOpenKategori2Menu = (event) => {
    setAnchorElKategori2(event.currentTarget);
  };

  const handleCloseKategori2Menu = () => {
    setAnchorElKategori2(null);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);


  };

  const handleCloseNavMenuClick = (to) => {
    if (pages.length > 0) {
      setDrawerOpen(false);
      navigate(to);
    }
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  const handleNavigateToDetails = (to) => {
    // Eskiden window.location.href (tam sayfa yenileme) ile gidiliyordu: Gatsby istemci geçişinde SSR liste sayfalarının
    // eski verisini gösteriyordu. Liste sayfaları artık açılışta veriyi tazeliyor (hooks/useTazeVeri), geçiş anında olur.
    navigate(to);
  }


  const handleNavigateToApp = () => {
    navigate('/');
  }

  const handleProfileClick = () => {
    setAnchorElUser(null);
    navigate('/login');

  };

  const handleLogout = () => {
    setAnchorElUser(null);
    logout();
  }


  React.useEffect(() => {

    const handlePageShow = (e) => {
      console.log('HANDLE PAGE SHOW'+e.persisted)
      if (e.persisted) { // bfcache’den geliyorsa
        setLoading(false); // spin kapat
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    setLoading(false);

    return () => window.removeEventListener("pageshow", handlePageShow);

  }, [])



  //?????????

  return (
    <AppBar position='sticky' sx={{ mt: '10px', mb: '5px', backgroundColor: '#FFF' }}>
      <Container maxWidth="lg" disableGutters>

        


        <Toolbar disableGutters>

          {/*<AdbIcon color='primary' sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />*/}

          <Typography
            variant="h6"
            noWrap
            component="span"
            onClick={handleNavigateToApp}
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: '#546e7a',
              textDecoration: 'none',
              //onClick:{handleNavigateToApp}  döngüye giriyor

            }}
          >

            <img
              src={logoImage}
              alt="Ürün Resmi"
              style={{ width: '200px' }}
            />




          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => setDrawerOpen(true)}
              color="#546e7a"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              PaperProps={{
                sx: { backgroundColor: "#2c2f33", color: "#f0f0f0", width: "70%" },
              }}
            >
              <List>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    pb: 1,
                    borderBottom: "1px solid rgba(255,255,255,0.2)"
                  }}
                >
                  {/* SVG */}
                  <Typography sx={{ ml: '20px', fontWeight: 800, fontStyle:'italic' }}> Fırsat Kategorileri </Typography>

                  {/* Close Button */}
                  <IconButton onClick={() => setDrawerOpen(false)} size="small" sx={{ color: "red" }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>




                {pages.map((page, id) => (
                  <ListItemButton key={id} onClick={() => handleCloseNavMenuClick(page.to)} sx={{
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    borderLeft: "20px solid transparent",
                    borderRight: "20px solid transparent",
                    "&:last-child": { borderBottom: "none" },
                  }}>
                    <ListItemText primary={page.name} />
                  </ListItemButton>
                ))}
              </List>
            </Drawer>


          </Box>
          {/*<AdbIcon color='primary' sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />*/}
          <Typography
            variant="h5"
            noWrap
            component="a"
            onClick={handleNavigateToApp}
            sx={{
              mr: 1,
              display: { xs: '1', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.1rem',
              color: '#546e7a',
              textDecoration: 'none',

            }}
          >

            <img
              src={logoImage}
              alt="Ürün Resmi"
              style={{ width: '200px' }}
            />


          </Typography>
          <Box sx={{ flexGrow: 2, display: { xs: 'none', md: 'flex', lg: 'none' } }}>
            {visible4Pages.map((page, id) => (
              <Button
                key={id}
                onClick={() => handleNavigateToDetails(page.to)}
                sx={{
                  color: "#546e7a",
                  fontWeight: 500,
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    width: "0%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "#546e7a",
                    transition: "width 0.3s ease",
                  },
                  "&:hover:after": {
                    width: "100%",
                  },
                }}
              >
                {page.name}
              </Button>
            ))}


            {/* DROPDOWN FOR REMAINING */}
            {(pages && pages.length > 0) &&
              <Button
                onClick={handleOpenKategoriMenu}
                endIcon={<ArrowDropDownIcon />}
                sx={{
                  color: "#546e7a",
                  fontWeight: 500,
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    width: "0%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "#546e7a",
                    transition: "width 0.3s ease",
                  },
                  "&:hover:after": {
                    width: "100%",
                  },
                }}
              >
                Kategoriler
              </Button>
            }
            {(pages && pages.length > 0) &&
              <Menu anchorEl={anchorElKategori} open={Boolean(anchorElKategori)} onClose={handleCloseKategoriMenu}>
                {overflow4Pages.map((page, id) => (
                  <MenuItem key={id} onClick={() => handleNavigateToDetails(page.to)}>
                    {page.name}
                  </MenuItem>
                ))}
              </Menu>
            }


          </Box>

          <Box sx={{ flexGrow: 2, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
            {visible6Pages.map((page, id) => (
              <Button
                key={id}
                onClick={() => handleNavigateToDetails(page.to)}
                sx={{
                  color: "#546e7a",
                  fontWeight: 500,
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    width: "0%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "#546e7a",
                    transition: "width 0.3s ease",
                  },
                  "&:hover:after": {
                    width: "100%",
                  },
                }}
              >
                {page.name}
              </Button>
            ))}


            {/* DROPDOWN FOR REMAINING */}
            {(pages && pages.length > 0) &&
              <Button
                endIcon={<ArrowDropDownIcon />}
                onClick={handleOpenKategori2Menu}
                sx={{
                  color: "#546e7a",
                  fontWeight: 500,
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    width: "0%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "#546e7a",
                    transition: "width 0.3s ease",
                  },
                  "&:hover:after": {
                    width: "100%",
                  },
                }}
              >
                Kategoriler
              </Button>
            }
            {(pages && pages.length > 0) &&
              <Menu anchorEl={anchorElKategori2} open={Boolean(anchorElKategori2)} onClose={handleCloseKategori2Menu}>
                {overflow6Pages.map((page, id) => (
                  <MenuItem key={id} onClick={() => handleNavigateToDetails(page.to)}>
                    {page.name}
                  </MenuItem>
                ))}
              </Menu>
            }


          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Kullanıcı İşlemleri">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <AssignmentIndIcon color='action' fontSize="large" sx={{ mr: 1 }} />
                {/*<Avatar alt="User" src={userImage} />*/}

              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {menuSettings.map((setting, id) => (
                <MenuItem
                  key={id}
                  onClick={() => (setting === 'Giriş Yap' ? handleProfileClick() : setting === 'Çıkış Yap' ? handleLogout() : handleCloseUserMenu())}>

                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>


      </Container>
    </AppBar >
  );
}
export default Header;
